import axios from 'axios'


const alldownloadAPI = async (basvuruId, filename) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/basvuru/alldownload/${basvuruId}`, {
        responseType: 'blob',
        headers: {
            authorization: 'bearer ' + localStorage.getItem('accessToken')
        }
    });
    try {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${basvuruId}.zip`)
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        return error
    }
};
export default alldownloadAPI;